const getRandomColor = () => {
    const colors = ['#CBCBCB', '#BAC0C7', '#C3BDB7', '#BDCAC3'];
    return () => {
        const num = Math.round(Math.random() * 3);
        return colors[num];
    };
};

export default getRandomColor;
